import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Top5ListCard = ({ title, icon, items, valueLabel = 'Total' }) => {
  return (
    <Card className="h-100 shadow-sm">
      <Card.Header as="h6" className="d-flex align-items-center">
        <FontAwesomeIcon icon={icon} className="me-2 text-primary" />
        {title}
      </Card.Header>
      <ListGroup variant="flush">
        {items && items.length > 0 ? (
          items.map((item, index) => (
            <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center small">
              <span>{index + 1}. {item.nome}</span>
              <span className="fw-bold">{item.valor}</span>
            </ListGroup.Item>
          ))
        ) : (
          <ListGroup.Item className="text-muted small text-center">
            Nenhum dado para exibir.
          </ListGroup.Item>
        )}
      </ListGroup>
    </Card>
  );
};

export default Top5ListCard;